import React, { useEffect, useState } from 'react';
import { Copy, ExternalLink } from 'lucide-react';
import client from '../../api/client';
import { Switch } from '../ui/switch';

export default function SeatFinderCard({ toast }) {
  const [cfg, setCfg] = useState(null);
  useEffect(() => { client.get('/seating/seat-finder').then((r) => setCfg(r.data)).catch(() => {}); }, []);
  if (!cfg) return null;
  const url = cfg.slug ? `${window.location.origin}/seat/${cfg.slug}` : '';
  const save = async (patch) => {
    setCfg({ ...cfg, ...patch });
    try { setCfg((await client.put('/seating/seat-finder', patch)).data); } catch (e) { toast({ title: 'Could not save', description: e.message, variant: 'destructive' }); }
  };
  const copy = async () => { await navigator.clipboard.writeText(url); toast({ title: 'Link copied' }); };
  return (
    <div className="soft-card rounded-2xl p-4 bg-white border border-[#EFE3D8] mb-4 flex flex-col md:flex-row md:items-center gap-4" data-testid="seat-finder-card">
      <div className="flex-1 min-w-0">
        <p className="font-serif text-lg text-[#2A2A2A]">Guest seat finder</p>
        <p className="text-xs text-[#6A6A6A]">Guests scan the QR code on the easel poster, or text <strong>SEAT</strong> and their name{cfg.text_number ? ` to ${cfg.text_number}` : ''}, to get their table number.</p>
        {url && cfg.enabled && (
          <div className="mt-2 flex items-center gap-2 text-xs">
            <span data-testid="seat-finder-url" className="truncate text-[#7B2C3B]">{url}</span>
            <button data-testid="seat-finder-copy" onClick={copy} className="p-1 text-[#9A8A7E] hover:text-[#7B2C3B]" title="Copy link"><Copy className="w-3.5 h-3.5" /></button>
            <a data-testid="seat-finder-open" href={url} target="_blank" rel="noreferrer" className="p-1 text-[#9A8A7E] hover:text-[#7B2C3B]" title="Open"><ExternalLink className="w-3.5 h-3.5" /></a>
          </div>
        )}
        {!cfg.slug && <p className="mt-2 text-xs text-[#B45309]">Publish your wedding website first to get a seat finder link.</p>}
      </div>
      <label className="flex items-center gap-2 text-sm text-[#3A3A3A]"><Switch data-testid="seat-finder-toggle-web" checked={cfg.enabled} onCheckedChange={(v) => save({ enabled: v })} /> QR lookup page</label>
      <label className="flex items-center gap-2 text-sm text-[#3A3A3A]"><Switch data-testid="seat-finder-toggle-sms" checked={cfg.sms_enabled} onCheckedChange={(v) => save({ sms_enabled: v })} /> Text lookup</label>
    </div>
  );
}
